import { useEffect } from 'react';
import { CAPACITOR_TEXT_ZOOM_PLUGIN } from '../../../capacitor_plugins/pluginConstants';
import { Capacitor } from '@capacitor/core';
import { TextZoom } from '@capacitor/text-zoom';

/**
 * This hook resets the text zoom level to 100% when the component mounts,
 * ensuring a consistent visual experience across the app.
 */
const useCapacitorTextZoomLevel = () => {
    useEffect(() => {
        if (Capacitor.isNativePlatform() && Capacitor.isPluginAvailable(CAPACITOR_TEXT_ZOOM_PLUGIN)) {
            TextZoom.set({
                value: 1,
            });
        }
    }, []);
};

export default useCapacitorTextZoomLevel;
